import { ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import { UiDisplayTagService } from "@vp/shared/store/ui";

@Component({
  selector: "vp-bottom-nav-copyright",
  templateUrl: "./bottom-nav-copyright.component.html",
  styleUrl: "./bottom-nav-copyright.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomNavCopyrightComponent {
  readonly uiDisplayTagService = inject(UiDisplayTagService);

  @Input() appCopyright!: string;
}
